export const firebaseConfig = {
    apiKey: "AIzaSyAAdHmTFznCMerdT99nrewJgISRvtxPqoY",
    authDomain: "gabinete-digital-2020.firebaseapp.com",
    databaseURL: "https://gabinete-digital-2020.firebaseio.com",
    projectId: "gabinete-digital-2020",
    storageBucket: "gabinete-digital-2020.appspot.com",
    messagingSenderId: "800733765231",
    appId: "1:800733765231:web:28e7792ab150006513779a",
    measurementId: "G-8QN4BLZ8XK"
};